<template>
  <div class="add_new_playlist_button">
    <div class="add_new_container">
      <span>+</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddPlaylistButton"
};
</script>

<style>
</style>